import { Button, ButtonProps, Typography } from "@timeedit/ui-components";
import cn from "classnames";
import { ReactNode } from "react";
import { Translations } from "../types";
import { ConflictNotification } from "../../Conflict";
import DeleteOutlined from "@timeedit/ui-components/icons/DeleteOutlined";
import WarningOutlined from "@timeedit/ui-components/icons/WarningOutlined";

type MultipleAllocationsProps = {
  buttonProps: ButtonProps;
  description: ReactNode;
  clash: boolean;
  linkedIssue: boolean;
  translations: Translations;
  onDeallocate: () => void;
};
export function MultipleAllocations({
  buttonProps,
  clash,
  linkedIssue,
  onDeallocate,
  translations,
}: MultipleAllocationsProps): React.JSX.Element {
  return (
    <>
      <div>
        <Button
          {...buttonProps}
          className={cn("tw:w-[112px] tw:p-0", buttonProps.className)}
          danger
          onClick={onDeallocate}
          icon={<DeleteOutlined alt="Delete" />}
        />
      </div>
      <Typography.Text type="danger">
        {translations.multipleAllocations}
      </Typography.Text>
      {clash && <ConflictNotification useText />}
      {linkedIssue && (
        <WarningOutlined
          className={"allocation-container--icon"}
          alt="Linked issue present"
        />
      )}
    </>
  );
}
